export interface Trainer {
  id: string;
  name: string;
  role: string;
  image?: string;
  experience: string;
  specialization: string[];
  description: string;
}

export const trainers: Trainer[] = [
  {
    id: 'toni',
    name: 'Toni Meier',
    role: 'Basis, IBgH, Agility und THS',
    image: '/images/team/toni.jpg',
    experience: 'Über 10 Jahre Erfahrung',
    specialization: ['Basis', 'IBgH', 'Agility', 'THS'],
    description: 'Toni leitet jeden Samstag das Training für unsere Gäste und danach für unsere Mitglieder. Er ist seit mehr als 10 Jahren im Verein tätig. Darüber hinaus übernimmt er die Rolle des 1. Vorsitzenden im Vorstand.'
  },
  {
    id: 'denise',
    name: 'Denise Broscheit',
    role: 'Basis',
    image: '/images/team/denise.jpg',
    experience: '2 Jahre im Verein',
    specialization: ['Basis'],
    description: 'Denise ist seit 2 Jahren in unserem Verein engagiert und hilft neben dem Training auch im Vorstand als 2. Vorsitzende. Sie hat insgesamt 4 Hunde, von denen einer bereits die BH bestanden hat.'
  },
  {
    id: 'catrin',
    name: 'Catrin Meyer',
    role: 'Rallye Obedience',
    experience: 'Seit 2022 im Verein',
    specialization: ['Rally Obedience'],
    description: 'Catrin ist seit 2022 aktives Mitglied im Verein. Als Trainerin für Rally Obedience liegt ihr der wertschätzende und respektvolle Umgang mit Mensch und Hund am Herzen. Mit ihrer Hündin liebt sie den freudbetonten kognitiven und physischen Ausgleich vom Alltag auf dem Platz.'
  },
  {
    id: 'rosmarie',
    name: 'Rosmarie Mrozewski',
    role: 'Agility und THS, Prüfungsleiter',
    experience: 'Langjährige Erfahrung',
    specialization: ['Agility', 'THS', 'Prüfungsleitung'],
    description: ''
  },
  {
    id: 'gabi',
    name: 'Gabi Rosenstreich',
    role: 'Rallye Obedience',
    experience: 'Mehrjährige Erfahrung',
    specialization: ['Rally Obedience'],
    description: ''
  }
];